import * as React from "react";
import { Button, Form, FormGroup, Input } from "reactstrap";
import { login } from "../../../Services/Auth";
import { useAuth } from "../../../Services/AuthContext";
import { isEmail } from "../../../utils/validation";
import useErrorHandler from "../../../utils/Hooks/ErrorHandler";
import ErrorMessage from "../../ErrorMessage";
import PasswordInput from "../../Editors/PasswordInput";
import LoadingAnimation from "../../Form/LoadingAnimation";




const validateLoginForm = (
    email,
    password,
    setError
) => {
    // Check for undefined or empty input fields
    if (!email || !password) {
        setError("Please enter a valid email and password.");
        return false;
    }
    // Validate email
    if (!isEmail(email)) {
        setError("Please enter a valid email address.");
        return false;
    }
    return true;
};



const LoginPanel = ({ setIndicitavePrice, setNewAccount, setForgotPassword }) => {
    const [userEmail, setUserEmail] = React.useState("");
    const [userPassword, setUserPassword] = React.useState("");
    const [loading, setLoading] = React.useState(false);
    const { error, showError } = useErrorHandler(null);
    const [user, dispatchSetuser] = useAuth();
    const authHandler = async () => {
        try {
            setLoading(true);
            const userData = await login(userEmail, userPassword, dispatchSetuser);
            //
            if (!userData.jwt) {
                setLoading(false);
                showError(userData.message);
            }
        } catch (err) {
            setLoading(false);
            showError(err.message);
        }
    };




    return user && user.jwt ?<LoadingAnimation/>:<React.Fragment>

            <Form
                onSubmit={e => {
                    e.preventDefault();
                    if (validateLoginForm(userEmail, userPassword, showError)) {
                        authHandler();
                    }
                }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'centre' }}>
                    <img alt='jetbidders' src={'/img/logo.png'} style={{ width: '60%', height: 'auto', marginTop: '5vh' }} />
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'centre' }}>
                    <div style={{ width: '80%', paddingTop:'15px'}}>
                        <h6>Contact us on <a href='tel::1300286462'>1300 286 462</a></h6>
                        <h3 style={{ marginTop: '40px', marginBottom: '40px' }}>Account Login</h3>
                        <FormGroup>
                            <Input size='lg'
                                type="email"
                                name="email"
                                value={userEmail}
                                placeholder="Your email"
                                autoComplete="username"
                                onChange={e => setUserEmail(e.target.value)}
                            />
                        </FormGroup>
                        <FormGroup>
                            <PasswordInput size='lg'
                                type="password"
                                name="password"
                                autoComplete="current-password"
                                value={userPassword}
                                placeholder="Password"
                                onChange={e => setUserPassword(e.target.value)}
                            />
                        </FormGroup>



                    </div>
                </div>
                <div style={{
                    display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'
                }}>
                    <div style={{ width: '80%' }}>
                        <div style={{ flexDirection: 'column', display: 'flex', justifyContent: 'space-between' }}>
                            <Button color='primary' type="submit" disabled={loading} block={true}>

                                {loading ? "Loading..." : "Sign In"}
                            </Button>
                        </div>
                        {error && <ErrorMessage errorMessage={error} />}

                        <Button className='link' color="secondary" onClick={() => setForgotPassword(true)} style={{ marginTop: '10px', marginBottom: '40px', height: '50px' }}>Forgot Password?</Button>


                    </div>
                </div>
                <div style={{
                    display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'
                }}>
                    <div style={{ width: '80%' }}>
                        <h3>Don't have an account?</h3>
                        <div style={{ flexDirection: 'column', display: 'flex', justifyContent: 'space-between' }}>
                            <Button color="secondary" style={{ marginTop: '15px', marginBottom: '15px' }} onClick={() => setNewAccount(true)}>Sign Up</Button>
                            <Button color="secondary" style={{ marginTop: '15px', marginBottom: '30px' }} onClick={() => setIndicitavePrice(true)}>Get an indicative price</Button>
                        </div>
                    </div>

                    <div style={{ width: '80%' }}>
                        <p>© Copyright Avmin {new Date().getFullYear()} All rights reserved</p>
                        <a href='https://www.avmin.com.au/privacy-policy'>Our Privacy Policy</a>
                    </div>
                </div>
            </Form>
        </React.Fragment>
    ;
}

export default LoginPanel;